import { BexioBill } from '@/bexio/bills'
import { entryStatus } from '@/db/schema/_types'
import { account, AccountResolved } from '@/db/schema/account'
import { user } from '@/db/schema/user'
import { sql } from 'drizzle-orm'
import { boolean, decimal, index, integer, jsonb, PgColumn, pgEnum, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'
import { z } from 'zod'

export const expenseType = pgEnum('expense_type', [
  'expense_training', // Weiterbildung
  'expense_bill', // Rechnung (Mit Bexio)
  'expense_bill_intern', // Rechung intern (Ohne Bexio)
  'expense_bill_intern_flatrate', // Pauschalspesen
  'expense_business_meal', // Geschäftsessen
  'expense_invoice_meal', // Verpflegungsspesen aus Leistung
])

export const expenseRecurrenceType = pgEnum('expense_recurrence', ['once', 'monthly'])

export const BexioBillSchema = {
  payerContactId: z.string().optional(),
  payer: z.any().optional(),
  accountantUserId: z.string().optional(),
  accountantUser: z.any().optional(),
  accountId: z.string().optional(),
  account: z.any().optional(),
  taxId: z.string().optional(),
  tax: z.any().optional(),
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const bexioBillSchema = z.object(BexioBillSchema)
export type BexioBillType = z.infer<typeof bexioBillSchema>

export const expense = pgTable(
  'expense',
  {
    id: serial('id').primaryKey(),
    slug: text('slug')
      .notNull()
      .default(sql`gen_random_uuid()`)
      .unique(),
    migrationId: text('migration_id'), // Migration ID
    integrationId: text('integration_id'), // Integration ID
    fileIntegrationId: text('file_integration_id'), // File upload in Bexio Integration ID
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    createdBy: integer('created_by')
      .notNull()
      .references((): PgColumn => user.id)
      .notNull(),
    issued: timestamp().defaultNow().notNull(),
    name: text('name').notNull(),
    description: text('description'),
    net: decimal().notNull().default('0'),
    gross: decimal().notNull().default('0'),
    vat: decimal().notNull().default('0'),
    url: text('url'),
    billFree: boolean('bill_free').notNull().default(false),
    status: entryStatus().notNull(),
    type: expenseType().notNull(),
    recurrence: expenseRecurrenceType().notNull(),
    parentId: integer('parent_id').references((): PgColumn => expense.id),
    sponsor: integer('sponsor')
      .references((): PgColumn => account.id)
      .notNull(),
    payer: integer('payer')
      .references((): PgColumn => account.id)
      .notNull(),
    bexio: jsonb().$type<BexioBillType>(),
  },
  (t) => ({
    slugIdx: index('expense_slug_idx').on(t.slug),
  })
)

export type Expense = typeof expense.$inferSelect & { bexioBill?: BexioBill }
export type ExpenseResolved = { expense: Expense; sponsor: AccountResolved; payer: AccountResolved }
export type InsertExpense = typeof expense.$inferInsert
export type UpdateExpense = Partial<Expense>
